import { createContext } from 'react';

var noop = function noop() {
  return;
};

var INITIAL_DATA = {
  activeItem: '',
  closeNavDrawer: noop,
  isNavDrawerOpen: false,
  openNavDrawer: noop,
  selectItem: noop,
  resetNavBarState: noop,
  shouldAnimate: true
};
export var HeaderStateContext = /*#__PURE__*/createContext(INITIAL_DATA);